import { Injectable, EventEmitter } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { Http, Headers } from '@angular/http';
import { Observable } from 'rxjs/Rx';
import 'rxjs/add/operator/map'

//  Services
import { HttpService } from '../services/http.service';
import { StorageService } from '../services/storage.service';
import { UtilityService } from '../services/utility.service';

//  Libraries
declare var $: any;
import * as moment from 'moment';

@Injectable()
export class AuthenticationService {

    private apiUrl: string
    private clientId: string = ''
    public Session$: EventEmitter<any>;
    private interval;

    constructor(
        private http: Http,
        private storageService: StorageService,
        private router: Router,
        private utilityService: UtilityService,
        private httpService: HttpService) {

        this.Session$ = new EventEmitter<any>();
        this.apiUrl = this.storageService.retrieve('rootApiUrl');
    }

    signIn(username: string, password: string) {

        var headers = new Headers({
            'Authorization': 'Basic ' + this.utilityService.base64EncArr(this.utilityService.strToUTF8Arr(username + ':' + password))
        });

        return this.http
            //for some reason this.apiUrl was not set when this was called. Call storage.retrieve here instead of using variable
            .get(this.storageService.retrieve('rootApiUrl') + '/auth/authenticate', { headers: headers })
            .map(response => response.json());
    }

    storeSession(session: any) {
        this.startSessionInterval(session.expires);
        this.storageService.store('session', session);
        this.Session$.emit(session);
    }

    retrieveSession(): any {

        let session = this.storageService.retrieve('session');

        if (!session && this.router.url.indexOf('/dashboard') != -1) {
            // this.router.navigate(['/signin']);
        }

        return session;
    }

    startSessionInterval(expiration: any) {
        
        var self = this;
        expiration = moment(new Date(expiration));
        
        this.interval = setInterval(function () {
            if (moment(new Date()) > expiration) {
                clearInterval(self.interval);
                self.clearSession();               
            }
        }, 1000);
    }

    clearSession() {
        clearInterval(this.interval);
        this.storageService.store('session', null);
        this.Session$.emit(null);
    }

    private handleError(error: any) {
        return Promise.reject(error.message || error);
    }
}



// WEBPACK FOOTER //
// ./src/app/services/authentication.service.ts